import { resetPwdSms, resetPwd } from '@/libs/api';
export default {
    name: "userCenter",
    components: {},
    data() {
        return {
            mobile: '',
            code: '',
            password: '',
            againPassword: '',
            passwordReg: /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$/,
            phoneReg: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
            canCode: false,
            time: 60 * 1000, //60秒
            isCountDown: false, // 是否可以倒计时
        };
    },
    created() { },
    mounted() {
        document.querySelector('body').classList.add('bg-fff');
        this.$once('hook:beforeDestroy', () => {
            document.querySelector('body').classList.remove('bg-fff');
        });
    },
    methods: {
        // 提交
        onSubmit() {
            // 手机号校验
            this.canCode = this.checkMobile(this.mobile);
            if (!this.canCode) return false;
            // 验证码校验
            let code = this.isCodeEmpty(this.code, '请输入验证码');
            if (!code) return false;
            // 密码校验
            let password = this.checkPassword(this.password);
            if (!password) return false;
            // 重复密码
            let againPassword = this.checkAgainPassword(this.againPassword);
            if (!againPassword) return false;
            // 验证成功后提交
            let user = {
                mobile: this.encrypted(this.mobile),
                newPwd: this.encrypted(this.password),
                validateCode: this.code
            }
            resetPwd(user).then(res => {
                if (res.returnCode === '0000') {
                    this.$toast('修改成功');
                    this.mobile = '';
                    this.code = '';
                    this.password = '';
                    this.againPassword = '';
                    setTimeout(() => {
                        this.$router.push('/user/login')
                    }, 500);
                } else {
                    this.code = '';
                    this.password = '';
                    this.againPassword = '';
                    this.$toast(res.returnMessage);
                }
            })
        },
        // 手机号校验
        checkMobile(moblie) {
            let hasMobil = this.isCodeEmpty(moblie, '请输入您的手机号');
            if (!hasMobil) {
                return false;
            } else {
                let isMoblie = this.isMoblie(moblie);
                if (!isMoblie) {
                    return false;
                }
                else {
                    return true;
                }
            }
        },
        // 密码校验
        checkPassword(password) {
            let hasPassword = this.isCodeEmpty(password, '请输入密码');
            if (!hasPassword) {
                return false;
            } else {
                let isPassword = this.isPassword(password);
                if (!isPassword) {
                    return false;
                }
                else {
                    return true;
                }
            }
        },
        // 重复密码校验
        checkAgainPassword(againPassword) {
            let hasAgainPassword = this.isCodeEmpty(againPassword, '请输入重复密码');
            if (!hasAgainPassword) {
                return false;
            } else {
                let isAgainPassword = this.isAgainPassword(againPassword);
                if (!isAgainPassword) {
                    return false;
                }
                else {
                    return true;
                }
            }
        },
        // 离开手机号输入框校验
        blurCheckMobil(moblie) {
            this.canCode = this.isCodeEmpty(moblie, '请输入您的手机号');
            if (!this.canCode) {
                return false;
            } else {
                this.canCode = this.isMoblie(moblie);
                if (!this.canCode) {
                    return false;
                }
                else {
                    return true;
                }
            }
        },
        // 校验为空
        isCodeEmpty(code, message) {
            if (code === '') {
                this.$toast(message);
                return false;
            }
            else {
                return true;
            }
        },
        // 校验手机
        isMoblie(moblie) {
            if (!this.phoneReg.test(moblie)) {
                this.$toast("请输入正确的手机号码");
                return false;
            } else {
                return true;
            }
        },
        // 校验密码
        isPassword(password) {
            if (!this.passwordReg.test(password)) {
                this.$toast("请输入6-20位字母与数字组合");
                return false;
            } else {
                return true;
            }
        },
        // 校验重复密码
        isAgainPassword(againPassword) {
            if (againPassword != this.password) {
                this.$toast("重复密码与新密码不一致，请重新输入");
                return false
            } else {
                return true;
            }
        },
        // 加密
        encrypted(str) {
            window.CryptoJS.pad.ZeroPadding = {
                pad: function (data, blockSize) {
                    // Shortcut
                    var blockSizeBytes = blockSize * 4;

                    // Pad
                    data.clamp();
                    data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
                },

                unpad: function (data) {
                    // Shortcut
                    var dataWords = data.words;

                    // Unpad
                    var i = data.sigBytes - 1;
                    while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
                        i--;
                    }
                    data.sigBytes = i + 1;
                }
            };
            var key = window.CryptoJS.enc.Latin1.parse('aZcdule123456782');
            var iv = window.CryptoJS.enc.Latin1.parse('0z234567ulebcde7');
            var encrypted = window.CryptoJS.AES.encrypt(str, key, {
                iv: iv,
                mode: window.CryptoJS.mode.CBC,
                padding: window.CryptoJS.pad.ZeroPadding
            });
            return encrypted.toString() || str;
        },
        // 获取短消息验证码
        getCode() {
            // 手机号校验
            let mobile = this.checkMobile(this.mobile);
            if (!mobile) return false;
            let params = {
                mobile: this.encrypted(this.mobile),
            }
            resetPwdSms(params).then(res => {
                if (res.returnCode === '0000') {
                    this.$toast("短消息验证码发送成功");
                    this.isCountDown = true;
                    this.$refs.countDown.start();
                } else {
                    this.$toast(res.returnMessage);
                }
            })
        },
        // 倒计时结束回调
        finish(e) {
            if (e.seconds === 0) {
                this.isCountDown = false;
                this.$refs.countDown.reset();
            }
        }
    },
};